import { Pipe, PipeTransform } from '@angular/core';
import { IButtonOption } from '../../components/data-input/form-inputs/button-group/button-group.component';
import { TariffSelectionAttributeValue } from '@web/dtos';

@Pipe({
  name: 'stringArraytoButtonOptionArray',
  standalone: true,
})
export class StringArrayToButtonOptionArrayPipe implements PipeTransform {
  transform(
    stringArray: TariffSelectionAttributeValue[]
  ): IButtonOption<TariffSelectionAttributeValue>[] {
    return stringArray.map((s: TariffSelectionAttributeValue) => {
      return {
        label: s || '',
        value: s,
      };
    });
  }
}
